import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd } from 'react-icons/md';
import { tidy_date, tidy_time_difference } from '../../utils/helper';
import DataTable from '../../components/ui/DataTable';

export default function ResourcesPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()

  const [resources, setResources] = useState([])
  const [loading, setLoading] = useState(true)
  const [query, setQuery] = useState("")

  useEffect(() => {
    fetchResources()
  }, [])

  const fetchResources = async () => {
    setLoading(true)
    let endpoint = config.endpoint + "/resources"
    let response = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
    let data = await response.json()
    if (data.status === 200) {
      setResources(data.data)
    }
    setLoading(false)
  }


  const table_columns = [
    {
      header: "Name",
      accessor: "name"
    },
    {
      header: "Availability",
      accessor: "available_from",
      modifier: (data, row) => `${tidy_date(row?.available_from)} - ${tidy_date(row?.available_to)}`,
    },
    {
      header: "Status",
      accessor: "is_published",
      modifier: (data) => (data ? "Published" : "Draft"),
    },
    {
      header: "Last Updated",
      accessor: "updatedAt",
      modifier: (data) => `${tidy_date(data)} (${tidy_time_difference(data)})`
    }
  ]


  return (
    <AdminLayout
      navSelected={"Resources"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Resources</h1>
          <button
            className="inline-flex items-center px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-sm transition-colors duration-200 gap-2"
            onClick={() => {
              navigate("/admin/resources/details?resource_id=new")
            }}
          >
            <MdAdd size={16} />
            New Resource
          </button>
        </>
      }
    >

      {/* <div className="column items-center justify-between w-100 mb-40">
        <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        />
      </div> */}

      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          {/* {resources.map((resource, index) => {
            if (!resource.name.toLowerCase().includes(query.toLowerCase())) return null
            return (
              <div
                key={index}
                className="flex-row items-center flex justify-between w-100 card mt-10"
              >
                <div className="">

                  <h3>{resource.name}</h3>
                  <h3 className='card-subtitle'>{tidy_date(resource.available_from)} - {tidy_date(resource.available_to)}</h3>
                </div>
                <button
                  className="button"
                  onClick={() => {
                    navigate("/admin/resources/details?resource_id=" + resource.id)
                  }}
                >
                  View
                </button>
              </div>
            )
          })} */}

          <DataTable
            columns={table_columns}
            data={resources}
            enableActions
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  <button className="hover:underline" onClick={() => navigate(`/admin/resources/details?resource_id=${row.id}`)}>
                    Edit
                  </button>
                </div>
              )
            }}
          />
        </div>
      )}
    </AdminLayout>
  )
}
